<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-col cols="12">
                <v-card>
                     <v-card-text>
                         <v-col cols="12" v-if="hasProblem">
                             Sorry, this feature is not currently available
                         </v-col>
                         <v-container fluid v-if="!isLoading && !hasProblem">
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <h2 class="mb-3">Reservation Confirmed</h2>
                                      <p>Clients credit card guarantee received. Reservation Confirmed</p>
                                      <p>All prices are in {{ reservation.hotel.hotel_name }}'s local currency {{ reservation.hotel.currency.currency_name }}</p>
                                      <p v-if="reservation.hotel.currency.currency_code != 'GBP'">Exchange rate for this record: {{ reservation.quote_exchange_rate }} {{ reservation.hotel.currency.currency_code }} to 1 GBP</p>
                                  </v-col>

                                  <v-col cols="3">
                                      <strong>Total Rate:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <v-layout wrap>

                                      <v-col cols="12" v-for="(unit, index) in reservation.units">
                                          <strong>{{ unit.room.name }} using {{ unit.rate_type.name }}:</strong>
                                          <v-container fluid>
                                               <v-layout row>

                                                  <v-col cols="12" class="pa-0">
                                                      <v-container fluid>
                                                          <v-layout row wrap>
                                                              <v-col cols="6" sm="3" class="pa-0">
                                                                  <strong>Date</strong>
                                                              </v-col>
                                                              <v-col cols="6" sm="3" class="pa-0">
                                                                  <strong>Rate ({{ reservation.hotel.currency.currency_code }})</strong> for {{ unit.total_guests }} guests
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  <strong>Total Daily Rate</strong>
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  <strong>Commission Rate (%)</strong>
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  <strong>Commission Amount ({{ reservation.hotel.currency.currency_code }})</strong>
                                                              </v-col>
                                                          </v-layout>
                                                      </v-container>
                                                  </v-col>

                                                  <v-col cols="12" v-for="(quoteDate, index) in unit.std_rates" class="pa-0">
                                                      <v-container fluid>
                                                          <v-layout row wrap>
                                                              <v-col cols="6" sm="3" class="pa-0">
                                                                  <strong>{{ quoteDate.date }}</strong>
                                                              </v-col>
                                                              <v-col cols="6" sm="3" class="pa-0">
                                                                  {{ quoteDate.rate.toFixed(2) }}
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  {{ quoteDate.rate }}**
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  {{ parseFloat(quoteDate.commission).toFixed(2) }}
                                                              </v-col>
                                                              <v-col cols="6" sm="2" class="pa-0">
                                                                  {{ (quoteDate.rate ? Math.round((quoteDate.rate / 100) * quoteDate.commission, 2) : '-') }}
                                                              </v-col>
                                                          </v-layout>
                                                      </v-container>
                                                  </v-col>


                                                  <v-col cols="3">
                                                      <strong>Total Rate:</strong>
                                                  </v-col>
                                                  <v-col cols="3">
                                                       {{ totalRates }}
                                                  </v-col>
                                                  <v-col cols="2">
                                                          {{ reservation.hotel.currency.currency_code }}
                                                  </v-col>
                                                  <v-col cols="3">&nbsp;</v-col>


                                                  <v-col cols="12" v-for="fee in reservation.additional_fees">
                                                      {{ fee.name }} {{ fee.fee_value }}
                                                  </v-col>



                                                 <v-col cols="3">
                                                     <strong>Total Cost Inclusive:</strong>
                                                 </v-col>

                                                 <v-col cols="9">
                                                     {{ parseFloat(reservation.quote_amount_local).toFixed(2) }} {{ reservation.hotel.currency.currency_code }}
                                                 </v-col>

                                              </v-layout>
                                          </v-container>
                                      </v-col>

                               </v-layout>
                               </v-col>


                                  <v-col cols="3">
                                      <strong>Deposit:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <div v-if="reservation.depositRequired"><strong>Deposit required at time of booking {{ parseFloat(reservation.deposit_amount_local).toFixed(2) }} {{ reservation.hotel.currency.currency_code }}</strong></div>
                                      <div v-if="reservation.is_advance_payment">Full pre-payment charged to the client by i-escape to secure the booking</div>
                                      <div v-if="reservation.hotel.collect_deposit == 1">Amount charged to the client by i-escape to secure the booking</div>
                                  </v-col>



                                  <v-col cols="3">
                                      <strong>Commission:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <div><strong>Charged at time of booking {{ parseFloat(reservation.commission_amount_local).toFixed(2) }} {{ reservation.hotel.currency.currency_code }}</strong></div>
                                      <div>(i-escape's commission on Total Rate above)</div>
                                  </v-col>



                               <v-col cols="3" v-if="reservation.voucher">
                                   <strong>Voucher:</strong>
                               </v-col>

                               <v-col cols="9" v-if="reservation.voucher">
                                   <div><strong>Value Redeemed {{ parseFloat(reservation.voucher.value).toFixed(2) }} GBP</strong></div>
                                   <div>{{ reservation.voucher.voucher_code }}</div>
                                   <div class="important-note">This client has booked using an i-escape voucher. Please charge the attached card the full balance payable below immediately on confirmation. If you have any problems please <a :href="contactIescapeUrl">contact i-escape</a>.</div>
                               </v-col>



                                  <v-col cols="3">
                                      &nbsp;
                                  </v-col>

                                  <v-col cols="9">
                                      <strong>Balance payable to {{ reservation.hotel.hotel_name }} {{ parseFloat(reservation.quote_amount_local - reservation.commission_amount_local).toFixed(2) }} {{ reservation.hotel.currency.currency_code }}</strong>
                                  </v-col>


                                  <v-col cols="3">
                                      <strong>Payment Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <v-layout row wrap>
                                          <v-col cols="12"  v-for="policy in getRateTypePolicies(reservation)">
                                              <div><strong>{{ policy.name }}</strong></div>
                                              <div>{{ policy.text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>


                                  <v-col cols="3">
                                      <strong>Cancellation Policy:</strong>
                                  </v-col>

                                  <v-col cols="9">
                                      <v-layout row wrap>
                                          <v-col cols="12"  v-for="policy in getCancellationPolicies(reservation)">
                                              <div><strong>{{ policy.name }}</strong></div>
                                              <div>{{ policy.text }}</div>
                                          </v-col>
                                      </v-layout>
                                  </v-col>


                                  <v-col cols="3" v-if="reservation.gift">
                                      <strong>i-escape Gift:</strong>
                                  </v-col>

                                  <v-col cols="9" class="important-note" v-if="reservation.gift">
                                      {{ reservation.gift }}
                                  </v-col>

                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions class="no-print">
                          <v-btn v-on:click="printReservation"><v-icon>print</v-icon> Print</v-btn>
                          <v-btn :href="contactIescapeUrl"><v-icon>email</v-icon> Contact i-escape</v-btn>
                          <v-btn :href="addToCalendarUrl"><v-icon>today</v-icon> Add to Calendar</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-col>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservations
     * by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    export default {
        name: 'hotel-reservation-enquiry',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                contactIescapeUrl: '',
                addToCalendarUrl: '',
                totalRates: 0.0,
                hasProblem: false,
                isLoading: true
            }
        },
        methods: {

            loadReservation(){
                try {
                this.isLoading = true;
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;

                    // Set a property to dictate whether the booking would require the client to pay a deposit
                    // The logic being if i-escape collects one for the hotel, or the rates require one, or the
                    // hotel's policy requires it for all bookings
                    console.log("quote accept: ",this.reservation);
                    this.reservation.depositRequired = this.reservation.hotel.collect_deposit || this.reservation.is_advance_payment || ((this.reservation.hotel.hotel_payment_policy.deposit_required == 1) || (this.reservation.hotel.hotel_payment_policy.deposit_required == 2));
                    if (!this.reservation.quote_expiry){
                        var date = new Date();
                        date.setDate(date.getDate() + 5);
                        this.reservation.quote_expiry = date.getUTCFullYear() +"-"+ (date.getUTCMonth()+1) +"-"+ date.getUTCDate();
                    }

                    var startDate = Date.parse(this.reservation.date_arrival);
                    console.log(startDate);
                    for(var index=0; index < this.reservation.stay_length; index++){
                        var datePointer = new Date(startDate.valueOf());
                        datePointer.setDate(datePointer.getDate() + index);
                        var dateString = datePointer.getUTCDate() + " " + this.getMonthAbbreviated(datePointer.getUTCMonth()) + " " + datePointer.getUTCFullYear() + ', ' + this.getDayAbbreviated(datePointer.getDay())
                        //this.quote.push({ "dateString": dateString, "date": date, "rateValue": 0.0 })
                    }
                    console.log(this.dateRange);

                    console.log("conf res: ", this.reservation);
                    this.contactIescapeUrl = "mailto:reservations@i-escape.com?subject=Reservation%20" + this.reservation.reference;
                    this.addToCalendarUrl = "/reservation/" + this.reservation.reservation_key + ".ics";
                    this.isLoading = false;
                }.bind(this));

                } catch(exception){
                    this.hasProblem = true;
                    console.log(exception);
                }
            },

            // To do - link to a printable page dedicated to outputting the information in a better format than this
            printReservation(){
               print();
            },


            /**
             * @method
             *
             * @param object reservation
             * @return array of view models for listing the payment policies
             * for the various rate types applied to this reservation without
             * duplication or requiring excessive processing in the view template
             */
            getRateTypePolicies(reservation){
                var policies = [];
                reservation.units.forEach(function(unit){
                    policies.push({'name': unit.rate_type.name, 'text': unit.rate_type.policy_payment_text});
                });
                return policies;
            },

            getCancellationPolicies(reservation){
                var policies = [];
                reservation.units.forEach(function(unit){
                    policies.push({'name': unit.rate_type.name, 'text': unit.cancellation_policy.policy_cancel_text});
                });
                return policies;
            },


            /**
             * Returns the day of the week by abbreviated name
             * e.g. 1 = "Mon", 2 = "Tue" etc
             */
            getDayAbbreviated(dayIndex){
                var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                return days[dayIndex];
            },

            /**
             * Returns the month of the year by abbreviated name
             * e.g. 1 = "Feb", 2 = "Mar" etc
             */
            getMonthAbbreviated(monthIndex){
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return months[monthIndex];
            },
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {}
    }
</script>
<style>
    .important-note {
        color: #F15C61;
    }
</style>
